import React from 'react';

import { ConfirmDialog, Stack, Typography, Grid } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';

import { COMMENT } from './constants';
import { FeedbackDialogSchema } from './schema';

import Reasons from './Reasons';

export const FeedbackDialog = withForm({
  validationSchema: FeedbackDialogSchema,
  enableReinitialize: true,
})(({
  values,
  open,
  confirmActionLabel = 'Save',
  submitForm,
  onExited,
  onClose,
}) => {
  const handleSubmit = () => {
    submitForm(values);
  };

  return (
    <ConfirmDialog
      title={'Submit Feedback'}
      open={open}
      confirmActionLabel={confirmActionLabel}
      onExited={onExited}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <Stack spacing={2}>
        <Typography>
          Your feedback will be sent to our Zendesk and reviewed by a Technical
          Support Agent.
        </Typography>

        <Reasons />

        <Grid item xs={12}>
          <FormField.TextField
            multiline={true}
            minRows={3}
            label={`Additional details`}
            helper={
              'Add context or suggestions to help us improve future responses.'
            }
            padding={0}
            name={COMMENT}
            autofocus={true}
          />
        </Grid>
      </Stack>
    </ConfirmDialog>
  );
});
